import Colors from "@constants/Colors";
import styled from "styled-components";

export const SettingsWrapper = styled.div`
  height: 100%;
  background: ${Colors.white};
`;

export const ListItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 24px 8px 48px;
  gap: 16px;
  height: 56px;
  border-bottom: 1px solid ${Colors.neutral_gray_300};
  justify-content: space-between;
`;

export const ProfileListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 24px 8px 43px;
  gap: 8px;
  justify-content: center;
  isolation: isolate;
  border-bottom: 1px solid ${Colors.neutral_gray_300};
  .content {
    font-family: "Ringside Regular-Book";
    font-style: normal;
    font-weight: 325;
    font-size: 16px;
    line-height: 24px;
  }
`;
